import { Contact } from 'models/Contact';

export type AddContactsPeopleTable = Pick<
  Contact,
  'email' | 'companyName' | 'preApproved' | 'firstName' | 'lastName' | 'title'
> &
  Record<'phoneNumber', string>;

export type AddContactsPeopleTableKeys = keyof AddContactsPeopleTable;

export const TABLE_COLUMNS: Array<AddContactsPeopleTableKeys> = [
  'preApproved',
  'firstName',
  'lastName',
  'phoneNumber',
  'email',
  'companyName',
  'title',
];

export const HEADER_OPTIONS: Partial<
  Record<typeof TABLE_COLUMNS[number], string>
> = {
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  phoneNumber: 'phone',
  companyName: 'company',
  title: 'title',
};

export const CUSTOM_COL_SIZES: Partial<
  Record<typeof TABLE_COLUMNS[number], number>
> = {
  preApproved: 80,
};

export const REQUIRED_COLUMNS = ['firstName', 'lastName', 'email'];

export const CHECKBOX_COLUMNS = ['preApproved'];
